export class CopilotPlanExtensions {
    constructor(planStorage, goals, loopWorkspaceCreationInProgress){
        this.planStorage = planStorage;
        this.goals = goals;
        this.loopWorkspaceCreationInProgress = loopWorkspaceCreationInProgress;
    }
}
export const CopilotPlanExtensionsKeys = new Set([
    "planStorage",
    "goals",
    "loopWorkspaceCreationInProgress"
]);
